import type { IZendeskChatApi } from '../types/Zendesk';

declare global {
  interface Window {
    zE: any;
  }
}

const WAIT_LOADING = 500;
const MAX_ATTEMPTS = 10;

class ZendeskChatApi implements IZendeskChatApi {
  constructor(private window: Window) {}

  static isApiAvailable() {
    return typeof window.zE !== 'undefined';
  }

  show() {
    this.window.zE('messenger', 'open');
  }

  close() {
    this.window.zE('messenger', 'close');
  }
}

export function zendeskProvider(window: Window) {
  if (ZendeskChatApi.isApiAvailable()) {
    return Promise.resolve(new ZendeskChatApi(window));
  }

  return new Promise((resolve, reject) => {
    let tick = 0;
    const interval = setInterval(() => {
      tick += 1;

      if (ZendeskChatApi.isApiAvailable()) {
        clearInterval(interval);
        resolve(new ZendeskChatApi(window));
      }

      if (tick > MAX_ATTEMPTS) {
        clearInterval(interval);
        reject(new Error('Can`t load zendesk api'));
      }
    }, WAIT_LOADING);
  });
}
